import React from "react";
import content from "../data/results/2023content.json";
import ResultsPage from "./ResultsPage";

const Results2023 = () => <ResultsPage content={content} />;

export default Results2023;
